/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $FantaTeamCreate = {
    properties: {
        name: {
            type: 'string',
            isRequired: true,
        },
        jerseyColor1: {
            type: 'string',
            isRequired: true,
        },
        jerseyColor2: {
            type: 'string',
            isRequired: true,
        },
        jerseyMode: {
            type: 'JerseyModeEnum',
            isRequired: true,
        },
        leagueId: {
            type: 'number',
            isRequired: true,
        },
    },
} as const;
